import { useState, Fragment, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";

import "./ksopBeneficiaryDesignation.css";
import { KSOPBeneficieryDesignationProps } from "../../../../../../../types/components/enrollmentProps.types";
import { KSOPOption } from "../../../../../../../types/enrollment.types";

const KsopBeneficiaryDesignation = ({ KSOPOption, setKSOPOption }: KSOPBeneficieryDesignationProps) => {
	const handleCheckedBoxValueClick = (_KSOPOption: KSOPOption) => {
		setKSOPOption(_KSOPOption);
	};

	return (
		<div className="ksop-beneficiary-designation">
			<div className="ksop-block">
				<div className="side-box">MUST CHECK ONE BOX</div>
				<div className="content-box-gray">
					<div className="title">Beneficiary Designation Choices (MUST CHOOSE OPTION 1,2, OR 3)</div>

					<div className="content" style={{ fontSize: "14px" }}>
						<Grid container spacing={0}>
							<Grid item xs={1}>
								<Grid container spacing={0} style={{ height: "100%" }}>
									<Grid item xs={6}>
										<div className="inside-item-bottom-border">
											<input
												type="checkbox"
												checked={KSOPOption === "1" ? true : false}
												onChange={() => handleCheckedBoxValueClick("1")}
											/>
										</div>
									</Grid>
									<Grid item xs={6}>
										<div className="inside-item-bottom-border">1.</div>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={11}>
								<div className="inside-item-bottom-border">
									<p>
										<b>
											Married with Spouse as Sole Beneficiary (Spouses signature is not required,
											but spouses name must be designated below.)
										</b>
									</p>
									<p>
										I am <b>Married</b> and designate my spouse named <b>below</b> to reeceive{" "}
										<b>all</b> death benefits from the plan.
									</p>
								</div>
							</Grid>

							<Grid container spacing={0}>
								<Grid item xs={1}>
									<Grid container spacing={0} style={{ height: "100%" }}>
										<Grid item xs={6}>
											<div className="inside-item-bottom-border">
												<input
													style={{ marginTop: "5px" }}
													type="checkbox"
													checked={KSOPOption === "2" ? true : false}
													onChange={() => handleCheckedBoxValueClick("2")}
												/>
											</div>
										</Grid>
										<Grid item xs={6}>
											<div className="inside-item-bottom-border">2.</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xs={11}>
									<div className="inside-item-bottom-border">
										<p>
											<b>
												Single Participants (including widowed, divorced, or legally separated)
											</b>
										</p>
										<p>
											I am Not <b>Married</b> and designate the individual(s) named <b>below</b>{" "}
											to receive death benefits from the plan. I understand if I<br></br>marry,
											this designation is void one year after my marriage (some plans specify a
											shorter period).<br></br>
											<b>
												Note: If changing your beneficiary due to a legal separation or divorce,
												then you must attach a copy of the court decree.
											</b>
										</p>
									</div>
								</Grid>
							</Grid>

							<Grid container spacing={0}>
								<Grid item xs={1}>
									<Grid container spacing={0} style={{ height: "100%" }}>
										<Grid item xs={6}>
											<div className="inside-item-bottom-border">
												<input
													style={{ marginTop: "5px" }}
													type="checkbox"
													checked={KSOPOption === "3" ? true : false}
													onChange={() => handleCheckedBoxValueClick("3")}
												/>
											</div>
										</Grid>
										<Grid item xs={6}>
											<div className="inside-item-bottom-border">3.</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xs={11}>
									<div className="inside-item-border">
										<div>
											<b>
												Married with Spouse NOT as Sole Primary Beneficiary (Spouse’s signature
												REQUIRED – Review QPSA consent on the back of this form.)
											</b>
											<br></br>I am <b>Married</b> and designate the individual(s) named{" "}
											<b>below</b> to receive death benefits in accordance with the plan
											provisions. <br></br>
											<b>
												Note: If you are married and do not name your spouse as the Sole Primary
												Beneficiary, your spouse must sign the consent. The signature must be
												witnessed by a Plan Representative or Notary Public. If you are younger
												than age 35, your spouse must again consent to this in writing at the
												start of the plan year in which you reach age 35 for this designation to
												remain in effect.
											</b>
											<div className="checkbox-flex">
												<div>
													<input
														style={{ marginTop: "5px", marginRight: "20px" }}
														type="checkbox"
														disabled
													/>
												</div>
												<div>
													<p>
														(Check if applicable) I certify that my spouse cannot be located
														to sign this consent. I will notify the plan sponsor if my
														spouse is located.<br></br>
														<b>
															Note: If your spouse cannot be located, check this box and
															have it witnessed by the Plan Representative. It must be
															established to the satisfaction of the Plan Representative
															that your spouse cannot be located.
														</b>
													</p>
												</div>
											</div>
										</div>
										<hr></hr>

										<Grid container spacing={0}>
											<Grid item xs={6}>
												<div className="inside-item-border">
													<b>
														I certify that it has been established to my satisfaction that
														spousal consent cannot be obtained because your spouse cannot be
														located.
													</b>
												</div>
											</Grid>
											<Grid item xs={5}>
												<div className="inside-item-border">
													<p>
														<b>Plan Representative’s Signature</b>
													</p>
													<p style={{ display: "flex" }}>
														<b>X</b>
														<div className="light-text"> &nbsp;Plan Signature</div>
													</p>
												</div>
											</Grid>
											<Grid item xs={1}>
												<div className="inside-item-border">
													<b>Date</b>
													<p className="light-text">MM/DD/YY</p>
												</div>
											</Grid>
										</Grid>
										<Grid container spacing={0}>
											<Grid item xs={6}>
												<div className="inside-item-border" style={{ fontSize: "14px" }}>
													<p>
														<b>Notice to Spouse:</b> In signing you are also verifying that
														you have read the QPSA notice and consent on the back of this
														form.
														<input
															style={{ paddingRight: "5px" }}
															type="checkbox"
															disabled
														/>
														By checking this box, I agree only to the beneficiary
														designation on this form. My spouse cannot change the
														beneficiary without my consent.
													</p>
												</div>
											</Grid>
											<Grid item xs={5}>
												<div className="inside-item-border" style={{ fontSize: "14px" }}>
													<b>
														Spouse&apos;s Signature (must be witnessed by Plan
														Representative or Notary Public)
													</b>
													<p style={{ display: "flex" }}>
														<b>X</b>
														<div className="light-text"> &nbsp;Spouse Signature</div>
													</p>
												</div>
											</Grid>
											<Grid item xs={1}>
												<div className="inside-item-border" style={{ fontSize: "14px" }}>
													<b>Date</b>
													<p className="light-text">MM/DD/YY</p>
												</div>
											</Grid>
										</Grid>

										<Grid container spacing={0}>
											<Grid item xs={4}>
												<div className="inside-item-border" style={{ fontSize: "14px" }}>
													<p>The spouse appeared before me and signed the consent on</p>
													<input
														className="input-bottom-border"
														type="text"
														placeholder="text"
														disabled
													></input>
												</div>
											</Grid>
											<Grid item xs={7}>
												<div className="inside-item-border" style={{ fontSize: "14px" }}>
													<b>Plan Representative or Notary Public Signature</b>
													<p style={{ display: "flex" }}>
														<b>X</b>
														<div className="light-text"> &nbsp;Signature</div>
													</p>
												</div>
											</Grid>
											<Grid item xs={1}>
												<div className="inside-item-border" style={{ fontSize: "14px" }}>
													<b>Date</b>
													<p className="light-text">MM/DD/YY</p>
												</div>
											</Grid>
										</Grid>
									</div>
								</Grid>
							</Grid>
						</Grid>
					</div>
				</div>
			</div>
		</div>
	);
};
export default KsopBeneficiaryDesignation;
